import React from 'react'

import Header from '../Header'
import ContentMenu from '../BurgerMenuContents/MenuContainer'
import { useOpen } from '../../hooks/Open'

export default function HeaderMenu() {
  const { OpenButton, open, returnDivMenu } = useOpen()

  return (
    <>
      <Header sidebar={OpenButton} open={open} returnDiv={returnDivMenu} />

      {open && (
        <ContentMenu />
      )}
    </>
  )
}
